<template>
  <b-form-group :label="properties.label">
    <b-input
      v-model="propertyValue"
      size="sm"
      :type="properties.type ? properties.type : 'text'"
    ></b-input>
  </b-form-group>
</template>

<script>
export default {
  name: "TextInputPropertyType",
  props: ["properties", "property", "value"],
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        let wrapperNewValue = newValue;
        if (this.properties.type == "number")
          wrapperNewValue = parseFloat(newValue);
        this.$emit("update-value", this.property, wrapperNewValue);
      }
    }
  }
};
</script>
